import { z } from "zod";
import { splitCamelCase } from "@/lib/utils";

export enum EKeyApiTransaction {
  AUTH = "authorized",
  BATCH = "batch",
  DECLINED = "declined",
  SETTLED = "settled",
  ALL = "all",
}
export const EKeyApiTransactionLabels: { [key in EKeyApiTransaction]: string } =
  {
    [EKeyApiTransaction.BATCH]: "Current Batch",
    [EKeyApiTransaction.AUTH]: "Authorized Transactions",
    [EKeyApiTransaction.SETTLED]: "Settled Transactions",
    [EKeyApiTransaction.DECLINED]: "Declined Transactions",
    [EKeyApiTransaction.ALL]: "All",
  };

export function isIncludesKeyKeyApiTransaction(
  value: string
): value is EKeyApiTransaction {
  return Object.values(EKeyApiTransaction).includes(
    value as EKeyApiTransaction
  );
}

export const filterTransaction = [
  { label: "Credit Sale", value: "100" },
  { label: "Debit Sale", value: "101" },
  { label: "Credit Return", value: "102" },
  { label: "Debit Return", value: "103" },
  { label: "Reversal", value: "104" },
  { label: "Return Reversal", value: "105" },
  { label: "Void", value: "106" },
  { label: "AuthOnly", value: "107" },
];
const paymentType = [
  "Card",
  "Incremental",
  "IncrementalCoF",
  "Recurring",
  "Installment",
  "CardOnFile",
  "Cash",
  "Check",
];
export const filterPaymentType = paymentType.map((value) => ({
  label: splitCamelCase(value),
  value,
}));
const transactionType = [
  "Sale",
  "AuthOnly",
  "AuthToSale",
  "Return",
  "Reversal",
  "ReturnReversal",
  "Store",
];
export const filterTransactionType = transactionType.map((value) => ({
  label: splitCamelCase(value),
  value,
}));

export const transactionSearchSchema = z.object({
  tab: z.nativeEnum(EKeyApiTransaction).catch(EKeyApiTransaction.BATCH),
});
